import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.AccountCreateLogin1,
  LocationVarKey.AccountCreateLogin2,
  {
    key: LocationVarKey.AfterNavigateAccountLoginCreateLogin,
    hideIf: IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1")
  },
  {
    key: LocationVarKey.AfterNavigateAccountLoginCreateLogin1,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1"),
      IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginCreateLogin, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
    ])
  },
  {
    key: LocationVarKey.AfterNavigateAccountLoginCreateLogin2,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1"),
      IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginCreateLogin, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
    ])
  }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Create Login
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AccountCreateLogin1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.AccountCreateLogin2}
        enableSwitchVar={LocationVarKey.AccountCreateLogin2Enabled}
      />

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1")}>
        <SwitchRow
          {...page}
          keyName={LocationVarKey.AfterNavigateAccountLoginCreateLogin}
          label="Ask if they want to be navigated to your Account Login URL"
        />
        <Section
          {...page}
          hideIf={IF_ANY([
            IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginCreateLogin, "1"),
            IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
          ])}
        >
          <SectionHeader
            {...page}
            subheading="After navigating the customer to a new page, the chat will open and respond based on the information below."
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginCreateLogin, "1")}
          >
            {" "}
            After Navigate{" "}
          </SectionHeader>
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginCreateLogin, "1")}
            marginTop
            label=" Message 1"
            keyName={LocationVarKey.AfterNavigateAccountLoginCreateLogin1}
          />
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginCreateLogin, "1")}
            marginTop
            label=" Message 2 (Optional)"
            keyName={LocationVarKey.AfterNavigateAccountLoginCreateLogin2}
            enableSwitchVar={LocationVarKey.AfterNavigateAccountLoginCreateLogin2Enabled}
          />
        </Section>
      </Section>
    </>
  );
}
